/* eslint-disable func-names */
/* eslint-disable react/no-unstable-nested-components */
// import { Typography } from 'antd';
import { Dispatch, SetStateAction } from 'react';
import { ReactMultiEmail } from 'react-multi-email';
import 'react-multi-email/dist/style.css';
import UserAddIcon from 'Components/common/assets/svgIcons/UserAddIcon';

// const { Text } = Typography;

interface MultiEmailInputFieldProps {
  emails: string[];
  setEmails: Dispatch<SetStateAction<string[]>>;
}

interface EmailLabelProps {
  email: string;
  index: number;
  removeEmail: (index: number) => void;
}

const EmailLabel = function ({ email, index, removeEmail }: EmailLabelProps) {
  return (
    <div
      data-tag
      key={index}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && removeEmail(index)}
    >
      <div data-tag-item>{email}</div>
      <span
        data-tag-handle
        onClick={() => removeEmail(index)}
        onKeyDown={(e) => e.key === 'Enter' && removeEmail(index)} // Support for keyboard interaction
        role="button"
        tabIndex={0}
      >
        ×
      </span>
    </div>
  );
};

const MultiEmailInputField = function ({ emails, setEmails }: MultiEmailInputFieldProps) {
  return (
    <form className="recepients-form">
      <div className="add-icon"><UserAddIcon /></div>
      <ReactMultiEmail
        placeholder="Add Guests"
        emails={emails}
        onChange={setEmails}
        autoFocus
        getLabel={(email, index, removeEmail) => (
          <EmailLabel
            email={email}
            index={index}
            removeEmail={index === 0 ? () => { } : removeEmail}
          />
        )}
      />
    </form>
  );
};

export default MultiEmailInputField;
